import TestimonyCard from "../ui/TestimonyCard";
import "./Testimony.css";
import person from "../../assets/person.png";

const testimonies = [
  {
    name: "Mario",
    rating: 5,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean ultricies enim eu metus molestie commodo et ut nisl. Suspendisse sodales.",
    image: person,
    alt: "Mario",
  },
  {
    name: "Luigi",
    rating: 4,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean ultricies enim eu metus molestie commodo et ut nisl. Suspendisse sodales.",
    image: person,
    alt: "Luigi",
  },
  {
    name: "Peach",
    rating: 3,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean ultricies enim eu metus molestie commodo et ut nisl. Suspendisse sodales.",
    image: person,
    alt: "Peach",
  },
  {
    name: "Bowser",
    rating: 2,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean ultricies enim eu metus molestie commodo et ut nisl. Suspendisse sodales.",
    image: person,
    alt: "Bowser",
  },
];

export default function Testimony() {
  return (
    <section id="testimony">
      <div className="container grid">
        <div id="testimony-header">
          <h2 style={{ color: "#F4CE14" }}>Testimony</h2>
        </div>
        <article id="testimony-cards">
          {testimonies.map((testimony, index) => (
            <TestimonyCard key={index} item={testimony} />
          ))}
        </article>
      </div>
    </section>
  );
}
